import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { takeUntil } from 'rxjs/operators' ;  import { Subject } from 'rxjs';
import { UserSessionService } from '../../../shared';
import { SelectizeComponent, ModalService } from '../../../blocks';

@Component({
    selector: 'Vacation-Request-PopUp',
    templateUrl: './vacation-request-popup.component.html',
})

export class VacationRequestPopUpComponent implements OnInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    
 
    constructor(
        public translate: TranslateService,
        private _userSessionService: UserSessionService,
        private _modalService: ModalService
    ) { }

    ngOnInit() {
      
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

 
}



